const vehicleReport = {
    namespaced: true,
    state: {
        vehicleReportList: [],
        vehicleReportListPromise: null,
        vehicleReportListLastUpdate: 0
    },
    mutations: {
        setVehicleReportList(state, newList) {
            state.vehicleReportList = newList;
            state.vehicleReportListLastUpdate = new Date().getTime();
        },
        setVehicleReportListPromise(state, promise) {
            state.vehicleReportListPromise = promise;
        }
    },
    actions: {
        getVehicleReportList(context) {
            return new Promise((resolve, reject) => {
                
                let now = new Date().getTime()
                if(context.state.vehicleReportList != []){
                    if(context.state.vehicleReportListLastUpdate + (25 * 1000) >= now){
                        resolve(context.state.vehicleReportList);
                        return;
                    }
                }

                if(context.state.vehicleReportListPromise != null){
                    // context.state.vehicleReportListPromise.then(() => {
                        resolve(context.state.vehicleReportList);
                        return;
                    // })
                }

                let promise = this._vm.$traveller_http.get('/traveller/restui/vehiclereport/getVehicleReportList')
                .then(function(response) {
                    context.commit('setVehicleReportList', response.data);
                    context.commit('setVehicleReportListPromise', null);
                    resolve(response.data);
                }).catch((error) => {
                    context.commit('setVehicleReportListPromise', null);
                    reject(error);
                })
                context.commit('setVehicleReportListPromise', promise);
            })

        }
    }
}
export default vehicleReport;